import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { EmailSourceType } from '../enums/enums'
import { CoreSettingsService } from '../settings/core-settings.service'

export type ContactsFormType = {
  contacts: string
  subject: string
  message: string
  userId: number
  secret: string
  sourceType: EmailSourceType
}

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  constructor(
    private http: HttpClient,
    private coreSettings: CoreSettingsService
  ) {}

  sendMessage(data: ContactsFormType): Observable<any> {
    const baseUrl = this.coreSettings.settings.baseUrl

    return this.http.post<Observable<any>>(`${baseUrl}/SendEmailToBeatmakerForProducerPage`, data)
  }
}
